import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateTime } from 'luxon';
import { useEffect, useMemo } from 'react';
import Text from '../../../../../components/Atoms/Text/Text';
import { TextSizeType } from '../../../../../shared/styling/BaseText/BaseText.enum';
import { Gray } from '../../../../constants/styles';
import { Hidden } from '../../../../media/Hidden';
import { Counter } from './components/Counter/Counter';
import { useCountdown } from './hooks/useCountdown';
import { PromoBarCloseIcon, PromoBarCloseIconWrapper, PromoBarWrapper, PromoTextWrapper, } from './PromoBar.styled';
const PROMOTION_END_SECOND = 0;
export const PromoBar = ({ data, isOpen, onCloseClick, onPromoBarExpired }) => {
    const promoEndDate = data ? DateTime.fromISO(data.endDate) : null;
    const formattedPromoEndDate = useMemo(() => promoEndDate
        ? DateTime.fromObject({
            day: +promoEndDate.toFormat('dd'),
            month: +promoEndDate.toFormat('MM'),
            year: +promoEndDate.toFormat('yyyy'),
            hour: +promoEndDate.toFormat('HH'),
            minute: +promoEndDate.toFormat('mm'),
            second: PROMOTION_END_SECOND,
        })
        : DateTime.now(), [promoEndDate]);
    const isPromoExpired = useMemo(() => formattedPromoEndDate.diffNow().milliseconds <= 0, [formattedPromoEndDate]);
    const promoBarEndDate = data && data.isActive ? DateTime.fromISO(data.endDate) : null;
    const formattedPromoBarEndDate = useMemo(() => promoBarEndDate
        ? DateTime.fromObject({
            day: +promoBarEndDate.toFormat('dd'),
            month: +promoBarEndDate.toFormat('MM'),
            year: +promoBarEndDate.toFormat('yyyy'),
            hour: +promoBarEndDate.toFormat('HH'),
            minute: +promoBarEndDate.toFormat('mm'),
            second: PROMOTION_END_SECOND,
        })
        : DateTime.now(), [promoBarEndDate]);
    const isPromoBarExpired = useMemo(() => formattedPromoBarEndDate.diffNow().milliseconds <= 0, [formattedPromoBarEndDate]);
    const remainingTime = useCountdown(formattedPromoBarEndDate);
    useEffect(() => {
        onPromoBarExpired(isPromoExpired);
    }, [isPromoExpired, onPromoBarExpired]);
    if (isPromoExpired || isPromoBarExpired || !data || !(data === null || data === void 0 ? void 0 : data.isActive)) {
        return null;
    }
    const { days, hours, minutes, seconds } = remainingTime;
    return (_jsxs(PromoBarWrapper, Object.assign({ backgroundColor: data.backgroundColor, fontColor: data.fontColor, isVisible: isOpen }, { children: [_jsxs(PromoTextWrapper, { children: [_jsx(Hidden, Object.assign({ greaterThanOrEqual: "small" }, { children: _jsx(Text, { as: "span", color: data.fontColor || Gray.x100, dangerouslySetInnerHTML: data && { __html: data.textMobile }, textSize: TextSizeType.TEXT16 }, void 0) }), void 0), _jsx(Hidden, Object.assign({ at: "small" }, { children: _jsx(Text, { as: "span", color: data.fontColor || Gray.x100, dangerouslySetInnerHTML: data && { __html: data.textDesktop }, textSize: TextSizeType.TEXT16 }, void 0) }), void 0)] }, void 0), data.hasCounter && _jsx(Counter, { days: days, hours: hours, minutes: minutes, seconds: seconds }, void 0), _jsx(PromoBarCloseIconWrapper, Object.assign({ onClick: onCloseClick }, { children: _jsx(PromoBarCloseIcon, { color: data.fontColor }, void 0) }), void 0)] }), void 0));
};
//# sourceMappingURL=PromoBar.js.map